import React, { useEffect } from 'react';
import { View, Text, Platform } from 'react-native';
import BottomSheetContainer from '../Bottomsheet/Bottomsheet';
import gs from '../../styles/globalStyles';
import { hideErrorSheet } from '../../store/slices/errorSlice';
import { useAppDispatch , useAppSelector } from '../../store/hooks';
import classes from '../../styles/globalClasses';
import SystemError from '../../../assets/Icons/SystemErrorIcon';
import Button from '../Button/Button';
import Typography from '../typography/Typography';
import { ColorTokens, TextAlignTokens, TypographyTypeDLS } from '@voltmoney/schema';
import { ThemedTouchableOpacity } from '@app/theme/Components';
import { X } from '../Icons/Icons';
import {useDarkMode} from '@app/utils';


const ErrorBottomSheet = () => {
  const errorSheetDetail = useAppSelector(state => state.errorSheet);
  const isDarkMode = useDarkMode()
  
  const dispatch = useAppDispatch();
  const { isErrorSheetVisible, errorType, errorMessage, closeOnBackdropPress , routeName } =
    errorSheetDetail;



  useEffect(() => {
    return () => {
      if (isErrorSheetVisible) {
        dispatch(hideErrorSheet());
      }
    };
    
  }, [isErrorSheetVisible]);

  const closeBottomSheet = () => {
    dispatch(hideErrorSheet());
  };
  return (
    <BottomSheetContainer
      isVisible={isErrorSheetVisible}
      close={closeBottomSheet}
      closeOnBackdropPress={closeOnBackdropPress ?? true}
      borderTopRightRadius={10}
      borderTopLeftRadius={10}
      containerStyle={gs.setBg('#fefefe')}>
      <View
        style={[
          // gs.flexOne,
          gs.alignItemsCenter,
          gs.justifyCenter,
          gs.setPadding(16),
        ]}>
        <View style={[gs.setMarginTop(20)]}>
          <SystemError size={36} />
        </View>
        <ThemedTouchableOpacity onPress={() => {
                closeBottomSheet();
             
               }} position='absolute' right={20} top={20}>
                <X size={20} color={isDarkMode?'#fff':'#000'}/>
               </ThemedTouchableOpacity>
        <View style={[gs.setMarginTop(16)]}>
          <Typography 
              typeDLS={TypographyTypeDLS.H4S}
              color={isDarkMode?ColorTokens.White :ColorTokens.Grey_Night}
              textAlign={TextAlignTokens.center}
              label={"Verification failed!"}
          />
        </View>
        <View
          style={[
            gs.setMarginTop(16),
            gs.setColor('#667085'),
            gs.setMarginBottom(24),
          ]}>
          <Text
            style={[classes.b1r, gs.setColor(isDarkMode?ColorTokens.White :'#667085'), gs.textAlignCenter]}>
            {errorMessage}
          </Text>
        </View>
        <Button
          eventName={routeName + '_EDIT'}
          label={'Edit details'}
          type={'SOLID'}
          handlePress={closeBottomSheet}
        />
      </View>
    </BottomSheetContainer>
  );
};

export default ErrorBottomSheet;
